$(document).ready(function () {
  // id^="1_kyc_document" means an id which starts with 1_kyc_document
  const kyc1 = $('[id^="0_kyc_document"]');
  const kyc2 = $('[id^="1_kyc_document"]');
  const kyc3 = $('[id^="2_kyc_document"]');
  const kyc4 = $('[id^="3_kyc_document"]');

  const add_button = $('#add-button');

  const remove_buttons = $('.remove-button');

  if (kyc4.data('persisted')) {
    add_button.addClass('d-none');
  } else if (kyc3.data('persisted')) {
    kyc4.addClass('d-none');
  } else if (kyc2.data('persisted')) {
    kyc4.addClass('d-none');
    kyc3.addClass('d-none');
  } else if (kyc1.data('persisted')) {
    kyc4.addClass('d-none');
    kyc3.addClass('d-none');
    kyc2.addClass('d-none');
  } else {
    kyc4.addClass('d-none');
    kyc3.addClass('d-none');
    kyc2.addClass('d-none');
    kyc1.addClass('d-none');
  }

  add_button.on("click", function() {
    if (kyc1.hasClass('d-none')) {
      kyc1.removeClass('d-none');
      $('input', kyc1).prop('disabled', false);
    } else if (kyc2.hasClass('d-none')) {
      kyc2.removeClass('d-none');
      $('input', kyc2).prop('disabled', false);
    } else if (kyc3.hasClass('d-none')) {
      kyc3.removeClass('d-none');
      $('input', kyc3).prop('disabled', false);
    } else if (kyc4.hasClass('d-none')) {
      kyc4.removeClass('d-none');
      $('input', kyc4).prop('disabled', false);
    }

    if (!kyc2.hasClass('d-none') && !kyc3.hasClass('d-none') && !kyc4.hasClass('d-none')) {
      add_button.addClass('d-none');
    }
  });

  remove_buttons.on('click', function() {
    const beneficialOwnerBlock = $(this).closest('.js-beneficial-owner-block');

    beneficialOwnerBlock.addClass('d-none');

    $('input', beneficialOwnerBlock).prop('disabled', true);

    add_button.removeClass('d-none');
  });
});
